import React from "react"
import { SRLWrapper } from "simple-react-lightbox"
import { GatsbyImage } from "gatsby-plugin-image"

import { makeStyles } from "@material-ui/core/styles"
// import { useTheme, makeStyles } from "@material-ui/core/styles"
// import { alpha } from "@material-ui/core/styles/colorManipulator"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
// import Typography from '@material-ui/core/Typography'
// import useMediaQuery from "@material-ui/core/useMediaQuery"
// import Masonry from "react-masonry-component"
// import { random } from "lodash"


const useStyles = makeStyles(theme => ({
  // galleryHeading: {
  //   fontFamily: 'Work Sans, Helvetica Neue, Roboto',
  //   fontWeight: 200,
  //   textTransform: 'uppercase',
  //   fontSize: '2.25rem',
  //   marginTop: '3rem'
  // },
  masonryGallery: {
    listStyle: "none",
    padding: "4.5rem 0",
    margin: 0,
  },
  masonryLi: {
    width: `calc(100% / 3 - 1rem)`,
    margin: "0.5rem",
    "& img": {
      objectFit: "cover",
      cursor: "pointer",
      height: "100%",
      width: "100%",
      borderRadius: 5,
    },
    [theme.breakpoints.down("sm")]: {
      width: `calc(100% / 2 - 1rem)`,
    },
  },
  galleryThumbnail: {
    width: '90%',
    "& img": {
      cursor: "pointer",
      padding: "0 1em",
      width: 400,
      height: 356,
      [theme.breakpoints.only('xl')]: {
        width: '90%',
        height: '90%',
        // height: 356,
      },
      [theme.breakpoints.only("lg")]: {
        width: 356,
        height: 300,
      },
      [theme.breakpoints.down("md")]: {
        width: 256,
        height: 225,
      },
      [theme.breakpoints.down("xs")]: {
        width: 178,
        height: 133,
      },
    },
  },
  gallery: {
    paddingBottom: "3.0em",
  },
}))
// const options = {
//   settings: {
//     overlayColor: "rgba(19, 37, 50, .95)",
//     autoplaySpeed: 0,
//     disableKeyboardControls: true,
//     disableWheelControls: true,

//   },
//   buttons: {
//     showAutoplayButton: false,
//     showNextButton: false,
//     showPrevButton: false,
//     showThumbnailsButton: false,
//   },
//   thumbnails: {
//     showThumbnails: false,
//   },
// }
const options = {
  settings: {
    overlayColor: "rgba(19, 37, 50, .95)",
  },
}
export default function PhotoGalleryComponent({
  title,
  description,
  imageList,
  gridImages,
}) {
  const classes = useStyles()
  // const theme = useTheme()
  // const matchesXS = useMediaQuery(theme.breakpoints.down("xs"))


  return (
    <SRLWrapper options={options}>
      <Grid
        container
        // style={{
        //   // backgroundColor: alpha(theme.palette.common.blue, 0.08),
        //    backgroundImage: `linear-gradient(rgba(0,0,0,0) 0%, ${alpha(theme.palette.common.blue, 0.08)} 1.25%, ${alpha(theme.palette.common.blue, 0.08)} 98.75%, rgba(0,0,0,0)`
        // }}
      >
        {/* <Container maxWidth="lg"> */}
        <Container maxWidth="xl">
          {/* <Grid item xs={12}>
            <Typography variant='h3' paragraph className={classes.galleryHeading} align='center'>Featured {title}s</Typography>
          </Grid> */}
          <Grid item xs={12}>
            <Grid container justifyContent="center" className={classes.gallery}>
              {imageList.slice(1).map(img => {
                return (
                  <Grid
                    key={img.id}
                    container
                    item
                    xs={6}
                    md={3}
                    lg={3}
                    xl={4}
                    justifyContent="center"
                    style={{ paddingTop: "2rem" }}
                  >
                    <GatsbyImage
                      image={img.gatsbyImageData}
                      alt={img.title}
                      imgStyle={{ marginLeft: "auto", marginRight: "auto", objectFit: 'cover', objectPosition: '50% 50%', }}
                      className={classes.galleryThumbnail}
                    />
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
          {/* <Grid item xs={12}>
            <Masonry className={classes.masonryGallery} elementType={"div"}>
              {imageList.slice(1).map(img => {
                const randomHeight = random(200, 600)
                const randomMobileHeight = random(100, 350)
                return (
                  <li
                    key={img.id}
                    className={classes.masonryLi}
                    style={{
                      height: matchesXS ? randomMobileHeight : randomHeight,
                    }}
                  >
                    <GatsbyImage
                      style={{ position: "initial" }}
                      image={img.gatsbyImageData}
                      alt={img.title}
                    />
                  </li>
                )
              })}
            </Masonry>
          </Grid> */}
        </Container>
      </Grid>
    </SRLWrapper>
  )
}
